module.exports = __webpack_public_path__ + "static/media/Team-invoice-pic-1.def08284.png";